/**
    红包
**/
<template>
  <div style="width: 1200px;
    margin: 30px auto;">
    <div class="wholeBox" v-loading="loading">
        <div class="infoBox">
            <span>收货地址 <el-divider direction="vertical"></el-divider> 大型商品下单后，收货地址将无法修改。</span>
            <span class="textRedColor">快递公司会电话联系您确认送货时间，收货时需核对身份证信息。</span>
        </div>
        <div class="getaddressList">
            <el-row>
                    <div >
                        <!-- <el-col v-if="item.defaultAddress==1?true:false"><span class="defaultAddressColor">默认地址</span></el-col> -->
                        <el-col  v-for="(item,index) in addressLists" :key="item.said" :class="isSelectedAddress==index+1?'isActive getaddressItem':'getaddressItem'">
                           <div @click="selectedAddress(index+1,item.said,item)">
                                <p><strong>姓名: </strong> {{item.recipient}}</p>
                                <p><strong>电话: </strong> {{item.phoneNumber}}</p>
                                <p class="twoLineDisplay"><strong>地址: </strong> {{item.areaName}} &nbsp; <span>{{item.address}}</span></p>
                                <p><strong>邮编: </strong> {{item.postalCode}}</p>
                                <span v-if="item.defaultAddress==1?true:false" class="defaultAddressColor">默认地址</span>
                                <div class="addressColor">
                                    <span @click="editAddress(item)" class="edit">修改</span>
                                    <!-- <span @click="deleteAddress(item.said)" class="delete">删除</span> -->
                                    <el-popconfirm
                                        confirm-button-text='确定'
                                        cancel-button-text='取消'
                                        confirm-button-type='danger'
                                        @confirm="deleteAddress(item.said)"
                                        icon="el-icon-info"
                                        icon-color="red"
                                        title="确定要删除吗？"
                                        placement='top'
                                        class="delete"
                                        >
                                        <el-button slot="reference">删除</el-button>
                                        </el-popconfirm>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span='4'>
                            <div class="getaddressItem addHover" @click="addAddress()">
                                <div class="el-icon-circle-plus addIcon"></div>
                                <p style="text-align: center;">添加地址</p>
                            </div>
                        </el-col>
                    </div>

            </el-row>

        </div>
    </div>
    <div class="orderBox">
        <!--<el-row class="payMethods">-->
            <!--<el-col :span="4">支付方式</el-col>-->
            <!--<el-col :span="20">-->
                <!--<el-radio-group v-model="payMethodsCheckbox">-->
                    <!--<el-radio-button label="1">在线支付</el-radio-button>-->
                    <!--&lt;!&ndash; <el-radio-button label="2">货到付款</el-radio-button> &ndash;&gt;-->
                <!--</el-radio-group>-->
            <!--</el-col>           -->
        <!--</el-row>-->
        <el-row class="payMethods">
            <el-col :span="4">发票</el-col>
            <el-col :span="20">
                <el-radio-group v-model="openradio">
                    <el-radio :label="1">不开发票</el-radio>
                    <el-radio :label="2">开发票</el-radio>
                </el-radio-group>
                <div class="invoiceBox" v-if="openradio==2?true:false">
                    <el-radio-group v-model="invoiceType">
                        <el-radio-button :label="1">电子发票（非纸质）</el-radio-button>
                        <el-radio-button :label="2">普通发票（纸质）</el-radio-button>
                        <el-radio-button :label="3">专用发票</el-radio-button>
                    </el-radio-group>
                    <el-radio-group v-if="invoiceType!=3" v-model="groupType">
                        <el-radio-button :label="1">个人</el-radio-button>
                        <el-radio-button :label="2">单位</el-radio-button>
                    </el-radio-group>
                    <el-form v-if="invoiceType!=3" label-position="left" ref="formLabelAlign" :rules="rules" label-width="80px"  :model="formLabelAlign">
                        <el-form-item label="抬头名称" prop="headerName">
                            <el-input v-model="formLabelAlign.headerName" placeholder="请输入发票抬头"></el-input>
                        </el-form-item>
                        <el-form-item v-if="groupType==2?true:false" label="公司税号" prop="taxNumber">
                            <el-input v-model="formLabelAlign.taxNumber" placeholder="请填写购买方纳税人识别号或统一社会信用代码"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-form v-if="invoiceType==3" label-position="left" ref="formLabelAlign" :rules="rules" label-width="80px"  :model="formLabelAlign">
                        <p style="font-size:16px;margin-bottom:10px">填写公司信息</p>
                        <el-form-item label="抬头名称" prop="headerName">
                            <el-input v-model="formLabelAlign.headerName" placeholder="请输入发票抬头"></el-input>
                        </el-form-item>
                        <el-form-item label="公司税号" prop="taxNumber">
                            <el-input v-model="formLabelAlign.taxNumber" placeholder="请填写购买方纳税人识别号或统一社会信用代码"></el-input>
                        </el-form-item>
                        <el-form-item label="注册地址" prop="registerAddress">
                            <el-input v-model="formLabelAlign.registerAddress" placeholder="请根据营业执照填写"></el-input>
                        </el-form-item>
                        <el-form-item label="注册电话" prop="registerphone">
                            <el-input v-model="formLabelAlign.registerphone" placeholder="请根据营业执照填写"></el-input>
                        </el-form-item>
                        <el-form-item label="开户银行" prop="bank">
                            <el-input v-model="formLabelAlign.bank" placeholder="请根据开户许可证照填写"></el-input>
                        </el-form-item>
                        <el-form-item label="银行账号" prop="bankNumber">
                            <el-input v-model="formLabelAlign.bankNumber" placeholder="请根据开户许可证照填写"></el-input>
                        </el-form-item>
                        <p style="font-size:16px;margin-bottom:10px">填写收票人信息</p>
                        <el-form-item label="姓名" prop="invoiceName">
                            <el-input v-model="formLabelAlign.invoiceName" placeholder="请输入2-20个字符"></el-input>
                        </el-form-item>
                         <el-form-item label="手机" prop="invoicePhone">
                            <el-input v-model="formLabelAlign.invoicePhone" placeholder="请输入11位手机号码"></el-input>
                        </el-form-item>
                         <el-form-item label="所在地区" prop="invoiceAddress">
                            <!-- <el-input v-model="formLabelAlign.taxNumber" placeholder="点击此处选择地区"></el-input> -->
                            <el-cascader
                                v-model="invoiceAddressValue"
                                ref="cascaderAddr"
                                class="cascaderArea"
                                placeholder="请选择收货地址"
                                :props="{ checkStrictly: true }"
                                :options="getprovince"
                                @change="invoiceAreaChange">
                            </el-cascader>
                        </el-form-item>
                         <el-form-item label="详细地址" prop="invoiceAddressDetail">
                            <el-input v-model="formLabelAlign.invoiceAddressDetail" placeholder="小区、门牌号等"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="more">
                        <dl>
                            <dt>发票须知：</dt>
                            <dd class="active">1.纸质发票暂不支持填写税号；付款后纳税人识别号不可修改，请确认信息后付款。</dd>
                            <dd>2.电子发票可在订单完成后，在订单详情中下载和查看。</dd>
                            <dd>3.发票金额为实际支付金额，不包含优惠券、礼品卡等。</dd>
                            <dd class="active">
                                <a @click="openCommonProblem">查看更多发票常见问题 &gt;</a>
                            </dd>
                        </dl>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="orderDetailText">
            <span>订单详情</span>
            <router-link to="/shoppingcart">返回购物车 ></router-link>
        </div>
        <el-row class="order_detailInfo">
            <div v-for="(shop,index1) in selectedOrderList" :key='index1'>
                <el-row style="margin: 10px 0;display: flex;align-items: center">
                  <span style="font-size: 22px;font-weight: bold;min-width: 150px">{{shop.name}}</span>
                  <div class="payMethodsNew" style="margin-left: 50px">
                    <el-radio-group v-model="shop.onlineOrOffline" @change="change1">
                      <el-radio-button :label="1">在线支付</el-radio-button>
                      <el-radio-button :disabled="shop.isSupportOfflinePay == 2" :label="2">线下打款</el-radio-button>
                    </el-radio-group>
                  </div>
                </el-row>
                <div v-for="(items,index) in shop.goods" :key='index'>
                    <el-row class="order_Info">
                        <el-col :span="1"> <el-image :src="`${items.photos}`"></el-image></el-col>
                        <el-col :span="15" class="order_Info_item OneLineDisplay">
                            <span style="cursor: pointer;" @click="$router.push(`/goodsdetail?id=${items.id}`)">{{ items.name }}</span>
                            <span v-if="buyNow">{{items.nameArr.length!=0?items.nameArr.toString():'默认规格'}} </span>
                            <span v-if="buyNow==false?true:false" style="cursor: pointer;color:#78b942;font-size:12px">{{items.cartSpecificationDetails!=null? items.cartSpecificationDetails.attributeContent:'默认规格' }}</span>
                        </el-col>
                        <el-col :span="6" class="order_Info_item" style="padding-left: 20px;">({{items.realprice || 0}}元 <i v-if='items.needPoints'>+{{items.needPoints || ' 0.00'}}积分</i>) x {{items.number}}</el-col>
                        <!-- <el-col :span="6" class="order_Info_item" style="padding-left: 20px;">({{(items.price!=null && items.price!="")?items.price: items.marketprice}}元 + 0.00积分) x {{items.number}}</el-col>            -->
                        <el-col :span="2" class="order_Info_item">有货</el-col>
                    </el-row>
                    <el-row :span="24" class="order_detailInfo_price">
                        <el-col :span="17">{{items.realprice * items.number}}元</el-col>
                        <!-- 满减 -->
                        <el-col :span="5" v-if="items.bxyCarPromotion!=null">
                            <span v-if='items.bxyCarPromotion.activityType==5' style="margin-right:10px"  class="addIcon">满减</span><span> {{items.bxyCarPromotion.cutfee}} x 1</span>
                        </el-col>
                        <!-- 满减 -->
                    </el-row>
                    <!-- 满即赠 -->
                    <div v-if="items.bxyCarPromotion!=null">
                         <el-row class="order_Info" v-for="fullgoods in items.bxyCarPromotion.addgoods" :key="fullgoods.goodsid">
                            <div v-if="items.bxyCarPromotion.activityType==3">
                                <div v-if="fullgoods.selectdata">
                                    <el-col :span="1"> <el-image :src="`${fullgoods.goodphoto}`"></el-image></el-col>
                                    <el-col :span="15" class="order_Info_item OneLineDisplay"><span style="cursor: pointer;">{{ fullgoods.goodname }}</span><span class="addIcon">赠品</span></el-col>
                                    <el-col :span="6" class="order_Info_item" style="padding-left: 20px;"> 0元  x 1</el-col>
                                    <el-col :span="2" class="order_Info_item">0 元</el-col>
                                </div>
                            </div>
                        </el-row>
                    </div>

                    <!-- 加价购 -->
                     <div v-if="items.bxyCarPromotion!=null">
                         <el-row class="order_Info" v-for="addPricegoods in items.bxyCarPromotion.addfeegoods" :key="addPricegoods.goodsid">
                            <div v-if="items.bxyCarPromotion.activityType==1">
                                <div v-if="addPricegoods.selectdata">
                                    <el-col :span="1"> <el-image :src="`${addPricegoods.goodphoto}`"></el-image></el-col>
                                    <el-col :span="15" class="order_Info_item OneLineDisplay"><span style="cursor: pointer;">{{ addPricegoods.goodname }}</span><span class="addIcon">加购商品</span></el-col>
                                    <el-col :span="6" class="order_Info_item" style="padding-left: 20px;"> {{addPricegoods.goodprice}}元  x 1</el-col>
                                    <!-- <el-col :span="2" class="order_Info_item">0 元</el-col>   -->
                                </div>
                            </div>
                        </el-row>
                     </div>

                     <!-- 满减 开始-->
                     <!-- <div v-if="items.bxyCarPromotion!=null">
                         <el-row class="order_Info" v-if="items.bxyCarPromotion.activityType==5">
                                    <el-col :span="15" class="order_Info_item OneLineDisplay"><span style="cursor: pointer;"></span><span class="addIcon">满减</span></el-col>

                        </el-row>
                     </div> -->
                    <!-- 满减 结束-->

                </div>
                <el-row class="Fee_Dtails">
                    <el-col :span="16"  class="Fee_Dtails_add">
                        <el-popover
                            class="envelopeListBox"
                            ref="popover"
                            placement="/bottom-end"
                            width="800"
                             v-model="visible"
                            trigger="click">
                            <div class="use_red">
                                <p>选择红包</p>
                                <el-row>
                                    <el-col
                                        :xs="12"
                                        :sm="6"
                                        :md="6"
                                        :lg="6"
                                        v-for="(item,index) in envelopeList"
                                        :key="index"
                                        class="bigoutBox"
                                    >
                                        <div class="wholeRedBox">
                                            <img
                                            v-if="item.icon!=''?true:false"
                                            class="img-responsive"
                                            :src="`${item.icon}`"
                                            />
                                            <div class="img-responsive" v-if="item.icon==''?true:false"><span class="noimg">暂无图片</span></div>
                                            <div class="text_right">
                                            <span style="
                                                font-size: 14px;
                                                color: #d93600;
                                                height: 32px;
                                                ">¥<em>{{item.redenvelopesPrice}}</em></span>
                                            <div style="color: #d93600;font-size: 14px">满{{item.subtotal}}元可用</div>
                                            <el-button type="text" class="getNow"  @click="getRedEnveloped(item.redenvelopesPrice,index1,item.id)">立即使用</el-button>
                                            </div>
                                        </div>
                                    </el-col>
                                    </el-row>
                                    <div v-if="envelopeList.length==0?true:false">
                                        <div> 您暂时没有可用的红包</div>
                                    </div>
                                <!-- <el-button slot="reference">确定</el-button> -->
                            </div>
                            <el-button slot="reference" @click="myReceivedPack(sumPrice(shop.goods,shop.redPackmoney),shop.bxmId)"><i class="el-icon-circle-plus"></i> 使用红包</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="8" class="Fee_Dtails_info">
                        <el-row class="Fee_Dtails_item">
                            <el-col :span="24" class="order_Info_item OneLineDisplay">商品数量：</el-col>
                            <el-col :span="24" class="order_Info_item">金额合计：</el-col>
                            <el-col :span="24" class="order_Info_item">会员折扣：</el-col>
                            <el-col :span="24" class="order_Info_item">活动优惠：</el-col>
                            <el-col :span="24" class="order_Info_item">红包抵扣：</el-col>
                            <el-col :span="24" class="order_Info_item">运费：</el-col>
                            <el-col :span="24" class="order_Info_item">总金额：</el-col>
                        </el-row>
                        <el-row class="Fee_Dtails_money">
                            <el-col :span="24" class="order_Info_item OneLineDisplay">{{totalNum(shop.goods)||1}}</el-col>
                            <el-col :span="24" class="order_Info_item">{{sumPrice(shop.goods)}}</el-col>
                            <el-col :span="24" class="order_Info_item">-{{memberdiscountNum(shop.goods)}}元</el-col>
                            <el-col :span="24" class="order_Info_item">-{{activityNum(shop.goods)}}元</el-col>
                            <el-col :span="24" class="order_Info_item">-{{shop.redPackmoney}}元</el-col>
                            <el-col :span="24" class="order_Info_item">{{transportfeeNum(shop.bxmId)}}元</el-col>
                            <el-col :span="24" class="order_Info_item">{{totalPrice(shop.goods,shop.redPackmoney,shop.bxmId)}}元</el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div class="nodate" v-if="selectedOrderList.length==0?true:false">
                 暂无数据 ！
            </div>
        </el-row>
        <el-row class="total_price">
            <el-col :span="21">
                应付总金额：
            </el-col>
            <el-col :span="3">
                <span class="total_price_color">{{payMoney()}}</span> 元
            </el-col>
        </el-row>
        <div v-show="!selected" style="text-align:right">
             <el-button type="primary" class="buttonBgd" @click="gotoAcount()">去结算</el-button>
        </div>
        <div v-show="selected" style="display: flex; justify-content: space-between;">
            <span>{{addressitemObj.recipient}} {{addressitemObj.phoneNumber!=null&& addressitemObj.phoneNumber!=''? encryption(addressitemObj.phoneNumber,4):''}} <br/> {{addressitemObj.areaName}} {{addressitemObj.address}} </span>
            <el-button :disabled='isDisabled' :icon="isDisabled?'el-icon-loading':''" type="primary" v-if="!buyNow" @click="orderNow()" class="buttonBgd">立即下单</el-button>
            <el-button :disabled='isDisabled' :icon="isDisabled?'el-icon-loading':''" type="primary" v-if="buyNow" @click="buyNowOrder()" class="buttonBgd">立即下单</el-button>
        </div>
    </div>


    <!-- 地址的弹框 -->
    <el-dialog
        :visible.sync="dialogVisible"
        :destroy-on-close='true'
        :close-on-click-modal="false"
        @close ='beforeClose'
        width="30%"
        class="dialogBox">
        <div v-show="showEditButtom?false:true" class="textCenter">添加收货地址</div>
        <div v-show="showEditButtom?true:false" class="textCenter">编辑收货地址</div>
        <span slot="footer" class="dialog-footer">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

                <el-form-item label="收件人" prop="recipient">
                    <el-input type="text" v-model="ruleForm.recipient" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phoneNumber">
                    <el-input type="text" v-model="ruleForm.phoneNumber" autocomplete="off"></el-input>
                </el-form-item>

                <!-- 添加地址时展示 -->
                <el-form-item label="地址" prop="areaid" v-show="showEditButtom?false:true">
                    <el-cascader
                        v-model="cascaderAreaValue"
                        ref="cascaderAddr"
                        class="cascaderArea"
                        placeholder="请选择收货地址"
                        :props="{ checkStrictly: true }"
                        :options="getprovince"
                        @change="areaHandleChange">
                    </el-cascader>
                </el-form-item>
                <!-- 修改地址时展示 -->
                <el-form-item label="地址" prop="areaid" v-show="showEditButtom?true:false">
                   <div class="addressCss"  v-if="areaName">
                        <span>{{areaName}}</span><span class="editCss" @click="isShowAddress">修改地址</span>
                   </div>
                    <!-- <el-input type="text" v-model="ruleForm.areaid" autocomplete="off"></el-input> -->
                    <el-cascader
                        v-else
                        v-model="cascaderAreaValue"
                        ref="cascaderAddr"
                        class="cascaderArea"
                        placeholder="请选择收货地址"
                        :props="{ checkStrictly: true }"
                        :options="getprovince"
                        @change="areaHandleChange">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                    <el-input v-model="ruleForm.address"></el-input>
                </el-form-item>
                <el-form-item label="邮政编码" prop="postalCode">
                    <el-input v-model="ruleForm.postalCode"></el-input>
                </el-form-item>
                <el-form-item prop="">
                    <el-checkbox v-model="ruleForm.defaultAddress">默认地址</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :disabled='comfiremdisabled' v-show="showEditButtom?false:true" @click="submintAddress()" class="buttonBgd">确 定</el-button>
                    <el-button type="primary" v-show="showEditButtom?true:false" @click="submintAddress('edit')" class="buttonBgd">确 定 修 改</el-button>
                </el-form-item>
                </el-form>
        </span>
    </el-dialog>

    <!-- 发票须知弹框 开始 -->
    <el-dialog
      class="seeMoreCommonProblemBox"
      :visible.sync="seeMoreCommonProblem"
      width="30%"
      title='发票常见问题'
      center
    >
      <div>
        <div class="modalContent">
            <h4>1.为什么当我选择开具单位抬头发票时，需要填写纳税⼈识别号？纳税⼈识别号哪⾥获取？</h4>
            <p>
                根据国家税务总局公告2017年第16号第⼀条规定：⾃2017年7⽉1⽇起，购买⽅为企业的，索取增值税普通发票时，应向销售⽅提供纳税⼈识别号或统⼀社会信⽤代码；销售⽅为其开具增值税普通发票时，应在“购买⽅纳税⼈识别号”栏填写购买⽅的纳税⼈识别号或统⼀社会信⽤代码。不符合规定的发票，不得作为税收凭证。纳税⼈识别号有两种⽅式获取：①联系公司财务咨询开票信息；②登录全国组织代码管理中⼼查询。<span class="light">（*商城⽬前使⽤的纸质发票类型属于通⽤机打发票，不在公告规定范畴内，发票规格本⾝⽆法添加税号，⽆需添加税号即可报销使⽤，所以暂不⽀持纸质发票填写单位企业税号。）</span>
            </p>
            <h4>2.非个人用户抬头的电子发票是否需要填写单位名称和纳税人识别号？</h4>
            <p>需要填写。国家税务总局要求，不符合规定的发票，不得作为税收凭证。</p>
            <h4>3.填写税号付款后是否可修改？</h4>
            <p>暂不支持修改，请认真确认后付款。</p>
            <h4>4.发票的类型有哪些？</h4>
            <p>目前可支持开具电子发票、通用机打发票。</p>
            <h4>5.发票⾦额包含优惠券、礼品卡吗？</h4>
            <p>发票⾦额为实际⽀付⾦额，不包含优惠券、礼品卡等。</p>
            <h4>6.什么是电⼦发票？</h4>
            <p>电⼦发票是指在购销商品、提供或者接受服务以及从事其他经营活动中，开具、收取的以电⼦⽅式存储的收付款凭证
                。⼩米⽹开具的电⼦发票均为真实有效的合法发票，与传统纸质发票具有同等法律效⼒，可作为⽤户维权、保修的有效凭据。</p>
            <h4>7.电⼦发票什么时候开具？</h4>
            <p>订单在⽤户确认收货，订单完成后开具电⼦发票。</p>
            <h4>8.电⼦发票在订单完成后，可在哪⾥查看？</h4>
            <p>订单完成后，你可以登录个人账户，在订单详情页中查看和下载PDF格式电子发票。</p>
            <h4>9.电⼦发票如何验证？</h4>
            <p>电⼦发票下载成功后，客户可凭借电⼦发票上所标⽰的发票代码、发票号码、防伪码在国税局授权的发票服务平台或北京市国家税局⽹站进⾏查询验证。</p>
            <h4>10.选择开具电⼦发票的顾客申请部分退货，发票如何处理？</h4>
            <p>开具电⼦发票的订单申请部分退货，原电⼦发票会通过系统⾃动冲红（原电⼦发票显⽰⽆效），并对未发⽣退货的商品重新⾃动开具电⼦发票。如整单退货，则我司将原电⼦发票做冲红处理（原电⼦发票显⽰⽆效）。</p>
            <h4>11.遇到质量问题，电⼦发票是否能作为维权的依据？</h4>
            <p>根据北京市国家税务局、北京市地⽅税务局、北京市商务委员会、北京市⼯商⾏政管理局《关于电⼦发票应⽤试点若⼲事项的公告》（2013年第8号）、《关于扩
                ⼤电⼦发票应⽤试点范围若⼲事项的公告》（2013年第18号⽂），电⼦发票与纸质发票具有相同法律效⼒，可作为售后、维权凭据。</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="seeMoreCommonProblem = false"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>
    <!-- 发票须知弹框 结束 -->

  </div>
</template>
<script>
import { immediatePlaceOrder,shoppingCartlist,get_order,addresslist,address_add,address_remove,address_saveedit,addOrder,area_list,getSpecificationselect,getMyred,getStoreFreight,coveragePrice  } from '@/api/xunyou'
import {mapState,mapMutations} from 'vuex'
export default {
  data() {
    return {
        // 线下打款的金额
        offlinePayMoney: 0,
        visible:false,
        activityType:'', // 接受积分的活动状态
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        isSelectedAddress:'',
        loading:false,
        showEditButtom:false,
        dialogVisible:false,
        selected:false,
        openradio:1,
        invoiceType:1,//是否是电子发票
        groupType:1, // 个人还是单位的
        formLabelAlign:{ // 发票里填写的内容
            headerName:'',
            taxNumber:'',
            registerAddress:'',
            registerphone:'',
            bank:'',
            bankNumber:'',
            invoiceName:'',
            invoicePhone:'',
            invoiceAddressDetail:'',
        },
        invoiceAddressValue:'',//收票人地址
        seeMoreCommonProblem:false, // 更多常见问题弹框
        cascaderAreaValue:[],
        ruleForm:{
            muid:JSON.parse(localStorage.getItem("userdata")).userId,
            recipient:'',
            phoneNumber:'',
            areaid:'',
            address:'',
            postalCode:'',
            defaultAddress:0,
        },
        redPackmoney:'',
        showpopover:'',
        envelopeList:[], // 我领取过的红包
        // getprovince:[], // 地址联动
        rules:{
            recipient: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            phoneNumber: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            areaid: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            address: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            postalCode: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            registerAddress: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            registerphone: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            bank: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            bankNumber: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            invoiceName: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            invoiceAddressValue: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            invoiceAddressDetail: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            invoicePhone: [{
                required: true,
                trigger: ["blur", "change"],
                validator:(rule, value, callback) => {
                        if (this.invoiceType != 3 && value=='') {
                          callback(new Error('不能为空,请输入'));
                        }else if(!/^[1][3,4,5,7,8][0-9]{9}$/.test(value)){
                            callback(new Error('请输入11位手机号'));
                        }else{
                          callback();
                        }
                      }
                },],
            headerName: [{ required: true,
             trigger: ["blur"] ,
             validator:(rule, value, callback) => {
                        if (this.groupType == 1 && value=='') {
                          callback(new Error('不能为空,请输入'));
                        }else if(this.groupType == 2 && value==''){
                            callback(new Error('不能为空,请输入'));
                        }
                        else{
                          callback();
                        }
                      }
            }],
            taxNumber: [{ required: true,
                trigger: ["blur"],
                validator:(rule, value, callback) => {
                        if (this.groupType == 2 && value=='') {
                          callback(new Error('不能为空,请输入'));
                        }else{
                          callback();
                        }
                      }

             }],
        },
        addressLists:[],
        selectedOrderList: JSON.parse(sessionStorage.getItem("selectList")) || [],
        scidArr:[],
        numberTotal:0,
        orderTitle:'',
        moneyTotal: 0, // 应付总额
        priceList:[], // 各个店铺总金额
        payMethodsCheckbox: 1, // 支付方式 在线支付/线下打款
        shopGoodsObj:[], // 店铺及其商品对应的集合
        selectedAddressId:'', // 选择的收货地址id
        addressitemObj:{},// 选中的地址对象
        storeFreightList:[], // 店铺运费
        activityPriceReq:0, // 店铺活动优惠
        memberPriceReq:0, // 店铺会员折扣
        buyNow:false, // 是否是从立即购买按钮跳转过来的
        // nameArr:[],// 展示属性
        // transportfee:0,
        areaName:'',
        comfiremdisabled:false,
        isDisabled:false,
        totalOrderNos:[]
    };
  },
  // 注册组件
  components: {},
    computed:{
    ...mapState(['getprovince'])
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.selectedOrderList.forEach(shop => {
      shop.onlineOrOffline = 1
    })
        // this.getCoverPrice();
  },
  mounted(){
    //  判断是否是通过 立即购买 按钮跳转过来的
    if(this.$route.query.buyNow){
        this.buyNow = true
        this.getCoverPrice();
    };
      this.getaddresslist()
    //   this.getprovinceList()
    //   let shopGoodsObj = [] // 店铺及其商品对应的集合
        this.scidArr=[]
      this.selectedOrderList.forEach((shop,redPackId)=>{
          let obj = {};
          let goodList = [];
          let mid = '';
          shop.redPackmoney = 0
          shop.redPackmoneyId = ''
          shop.goods.forEach((item)=>{
            item.nameArr=[]
            if(item.specificationlist!=null){
                item.nameArr =  this.getSpecification(item.specificationlist[0].id)
            }
                let child ={
                    type:item.bxyCarPromotion!=null?item.bxyCarPromotion.activityType:'',
                    id: item.id,
                    number:item.number,
                    realprice:item.realprice,
                    bxysid:this.buyNow?(shop.selectAttrId||0):(item.cartSpecificationDetails!=null?item.cartSpecificationDetails.id:0), // 判断是否是取值
                    // bxysid:item.specificationlist!=null?item.specificationlist[0].id:0,
                    // bxysid:item.cartSpecificationDetails!=null?item.cartSpecificationDetails.id:0,
                    bXyFeeDetail: {
                        goodsfee: item.bxyFeeDetail!=null?item.bxyFeeDetail.goodsfee:0,  //商品原价
                        totalfee: item.bxyFeeDetail!=null?item.bxyFeeDetail.totalfee:0,  //商品实际支付价格
                        memberdiscount: item.bxyFeeDetail!=null?item.bxyFeeDetail.memberdiscount:0,  //会员折扣费用
                        activitydiscount: item.bxyFeeDetail!=null?item.bxyFeeDetail.activitydiscount:0,  //活动优惠费用
                        pointfee: item.bxyFeeDetail!=null?item.bxyFeeDetail.pointfee:0,  // 积分数
                    }
                }
                mid = item.mid
                this.scidArr.push(item.scid) // 购物车id集合
                goodList.push(child)
                if(item.bxyMarketing){
                    this.activityType = item.bxyMarketing.activityTypeId
                }
                if(item.bxyCarPromotion!=null){
                // 满即赠
                    if(item.bxyCarPromotion.activityType==3){
                         item.bxyCarPromotion.addgoods.forEach(fullitem=>{
                            if(fullitem.selectdata){
                                let fullchild = {
                                    type:item.bxyCarPromotion.activityType,
                                    id: fullitem.goodid,
                                    number:1,
                                    realprice:0,
                                    bxysid:fullitem.specificationid,
                                    genre: 0,
                                    activity:true, // 只查主商品的运费（区别是不是活动商品）
                                    bXyFeeDetail: {
                                        goodsfee: 0,  //商品原价
                                        totalfee: 0,  //商品实际支付价格
                                        memberdiscount: 0,  //会员折扣费用
                                        activitydiscount: 0,  //活动优惠费用
                                        pointfee: 0,  // 积分数
                                    }
                                }
                                goodList.unshift(fullchild)
                            }
                        })
                    } else if(item.bxyCarPromotion.activityType==1){
                        // 加价购
                        item.bxyCarPromotion.addfeegoods.forEach((addPriceItem,index)=>{
                            if(addPriceItem.selectdata){
                                // console.log(index,'加价购-index------------------------------------------------')
                                let addPricechild = {
                                    type:item.bxyCarPromotion.activityType,
                                    id: addPriceItem.goodid,
                                    number:1,
                                    realprice:addPriceItem.goodprice,
                                    bxysid:addPriceItem.specificationid,
                                    genre: 0,
                                    activity:true, // 只查主商品的运费（区别是不是活动商品）
                                     bXyFeeDetail: {
                                        goodsfee: addPriceItem.goodprice||0,  //商品原价
                                        totalfee: addPriceItem.goodprice||0,  //商品实际支付价格
                                        memberdiscount:0,  //会员折扣费用
                                        // memberdiscount: item.bxyFeeDetail!=null?item.bxyFeeDetail.memberdiscount:0,  //会员折扣费用
                                        activitydiscount: item.bxyFeeDetail!=null?item.bxyFeeDetail.activitydiscount:0,  //活动优惠费用
                                        pointfee: item.bxyFeeDetail!=null?item.bxyFeeDetail.pointfee:0,  // 积分数
                                    }
                                }
                                goodList.unshift(addPricechild)
                                // console.log(goodList,'加价购-------------------------------------------------')
                            }
                            })
                    }
                }
          })
          obj = {
                bxmId:mid,
                title:shop.goods[0].name, // 订单标题
                amount:0, // 应付总金额
                // amount:this.totalPrice(shop.goods,shop.redPackmoney,shop.bxmId),
                said:this.selectedAddressId,   // 收货id
                // type:this.payMethodsCheckbox,//支付方式
                redPay:shop.redPackmoney, // 红包抵扣
                rid:shop.redPackmoneyId, // 红包id
                discountOffer:'', // 会员折扣
                activitydiscountOffer:'', // 活动优惠
                transpotfee:'', // 运费
                goodsList:goodList
          }
           this.shopGoodsObj.push(obj)
        })
        // this.get_orderList(this.selectedOrderList)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    change1() {
      this.$forceUpdate()
    },
    isShowAddress(){
        this.areaName = ''
    },

    //   红包选择
    getRedEnveloped(money,index,axyRid){
        this.selectedOrderList.forEach((shop,key)=>{
            if(key == index){
                // debugger
                this.selectedOrderList[key].redPackmoney = money; // 用于页面的展示
                this.shopGoodsObj[key].redPay = Number(money); // 记录到下单的请求参数里面
                this.shopGoodsObj[key].rid = axyRid; // 记录到下单的请求参数里面
            }
        })
         var elements = document.getElementsByClassName('el-popover el-popper');
         Array.prototype.forEach.call(elements, function (element) {
            element.style = 'display:none';
        });
        this.getaddresslist() // 调此接口 为了刷新页面 （让红包及时展示）
    },
    //  个人信息加密
    encryption(str, len) {
      if (str.length <= len) {
        return str;
      } else {
        var newStr = str.substring(0, 3);
        var newStrs = str.substring(str.length , str.length - 4);
        newStr = newStr + "****" + newStrs;
        return newStr;
      }
    },

    getSpecification(id){
        let nameArr = []
        getSpecificationselect({specificationId:id||0})
            .then(res => {
              if (res.code == 0) {
                  res.rows.forEach((item)=>{
                     nameArr.push(item.bXyAttributeList[0].name)
                  })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        return nameArr
    },

    //   选择收货地址
    selectedAddress(index,selectedAddressId,itemObj){
            this.addressitemObj = itemObj
            this.selected = true;
            this.isSelectedAddress = index;
            this.selectedAddressId = selectedAddressId
            let storesList = []
            this.shopGoodsObj.forEach((item)=>{
                let goodsList = []
                item.goodsList.forEach((goodsItem)=>{
                    let goods = {}
                    if(!goodsItem.activity){ // 只查主商品的运费
                        goods = {
                            id: goodsItem.id,
                            number: goodsItem.number,
                            specId: goodsItem.bxysid,
                        }
                        goodsList.push(goods)
                    }
                })
                let obj = {}
                obj = {
                    bxmId:item.bxmId,
                    goodsList:goodsList
                }
                storesList.push(obj)
            })
            const req = {
                said:this.selectedAddressId, // 收货地址
                storesList:storesList // 店铺信息
            }
            if(this.selectedAddressId){
                // 调修改运费接口
                getStoreFreight(req)
                .then(res => {
                if (res.data.code == 0) {
                    this.storeFreightList = res.data.data
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                this.$message.error('查询运费失败，请稍后再试！')
                })
            }
    },
    // 填写地址选择
    areaHandleChange(value){
                this.$refs['cascaderAddr'].getCheckedNodes()
                this.ruleForm.areaid = value[value.length-1]
    },

     // 发票地址选择
    invoiceAreaChange(value){
        this.formLabelAlign.invoiceAddress =  String(this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels).replace(/,/g,'')
    },

    //  计算店铺商品数量
    totalNum(data){
        //    debugger
           let total = data.reduce((sum, item) => {
            let addPriceGoods=0
            if(item.bxyCarPromotion!=null){
                  if(item.bxyCarPromotion.activityType==1){
                    //  加价购
                    item.bxyCarPromotion.addfeegoods.forEach((addPriceitem)=>{
                        if(addPriceitem.selectdata){
                                addPriceGoods+= 1;
                        }
                    })
               }
               else if(item.bxyCarPromotion.activityType==3){
                    //  满即赠
                    item.bxyCarPromotion.addgoods.forEach((additem)=>{
                        if(additem.selectdata){
                                addPriceGoods+= 1;
                        }
                    })
               }
            }
                return sum + item.number+addPriceGoods; // 隐式转换

            }, 0);
            return total;
    },
    //   计算店铺金额合计
     sumPrice(data){
        let sumPrice = data.reduce((sum, item) => {
            item.bxyCarPromotion!=null?item.bxyCarPromotion.addfeegoods.forEach((addPriceItem)=>{
                addPriceItem.selectdata?sum+=Number(addPriceItem.goodprice):0
            }):0
            // if(item.bxyCarPromotion!=null&&item.bxyCarPromotion.activityType==5){
            //     sum-=Number(item.bxyCarPromotion.cutfee)
            // }
              return (sum + item.number * item.realprice); // 隐式转换
          }, 0);
          return sumPrice.toFixed(2);
     },
    //   计算店铺总金额
     totalPrice(data,num = 0,storeId){
         const freeNum = this.storeFreightList.length>0?this.transportfeeNum(storeId):0
         let totalPrice = this.sumPrice(data) - num - this.memberdiscountNum(data)-this.activityNum(data); //金额合计 - 红包抵扣 - 会员折扣 - 活动优惠 + 运费
         totalPrice = Number(freeNum)+Number(totalPrice)
         return totalPrice.toFixed(2)
     },

    // 店铺会员折扣总合计
    memberdiscountNum(data){
         let memberPrice = data.reduce((sum, item) => {
              return sum + (item.bxyFeeDetail!=null?item.bxyFeeDetail.memberdiscount*item.number:0) // 隐式转换
          }, 0);
          this.memberPriceReq = memberPrice
          return memberPrice.toFixed(2);
    },

    // 店铺活动优惠总合计
    activityNum(data){
        let activityPrice = data.reduce((sum, item) => {
              return sum + (item.bxyFeeDetail!=null?item.bxyFeeDetail.activitydiscount:0) // 隐式转换
          }, 0);
          this.activityPriceReq = activityPrice
          return activityPrice.toFixed(2);
    },

    // 店铺里总的运费合计
    transportfeeNum(storeId){
        let sum = 0
        this.storeFreightList.forEach(item=>{
            if(item.bxmId==storeId){
               sum = Number(item.transpotfee)
            }
        })
          return sum.toFixed(2)
    },

     //   应付金额
    payMoney(){
            let payMoney = 0;
            this.selectedOrderList.forEach((shop)=>{
                const everyStorePrice =  this.totalPrice(shop.goods,shop.redPackmoney,shop.bxmId);
                payMoney = Number(payMoney)+ Number(everyStorePrice)
            })
            return Number(payMoney).toFixed(2);
    },

      // 添加地址
      addAddress(){
          this.dialogVisible= true
      },
    //   关闭弹框清空
      beforeClose(){
          this.ruleForm = {}
          this.cascaderAreaValue = []
          this.showEditButtom = false
      },
    //   新增收货地址
      submintAddress(item){
        //   console.log(editReq,'xiugai1')
          if(item == 'edit'){
              this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                     let editReq = {
                        muid:this.ruleForm.muid,
                        said:this.ruleForm.said,
                        recipient:this.ruleForm.recipient ,
                        phoneNumber:this.ruleForm.phoneNumber ,
                        areaid:this.ruleForm.areaid ,
                        address:this.ruleForm.address,
                        postalCode:this.ruleForm.postalCode ,
                        defaultAddress:this.ruleForm.defaultAddress?1:0
                    }
                    address_saveedit(editReq)
                        .then(res => {
                        if (res.code == 0) {
                            this.showEditButtom = false
                            this.dialogVisible= false
                            this.ruleForm = {}
                            this.cascaderAreaValue=[]
                            this.getaddresslist()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.msg
                            })
                        }
                        })
                        .catch(err => {
                        this.dialogVisible= false
                        this.$message.error('修改失败，请稍后再试！')
                        })
                    }
                });
          }else{
              this.$refs.ruleForm.validate((valid) => {
                  this.ruleForm.muid = this.userInfo.userId,
                   this.ruleForm.defaultAddress=this.ruleForm.defaultAddress?1:0
                if (valid) {
                    this.comfiremdisabled = true
                    address_add(this.ruleForm)
                        .then(res => {
                        if (res.code == 0) {
                            this.dialogVisible= false
                            this.comfiremdisabled = false
                            this.ruleForm = {}
                            this.getaddresslist()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.msg
                            })
                            this.comfiremdisabled = false
                        }
                        })
                        .catch(err => {
                        this.dialogVisible= false
                        this.$message.error('提交失败，请稍后再试！')
                        })
                    }
                });
          }
      },

    //   删除地址
    deleteAddress(deleteId){
        address_remove({ids:deleteId})
            .then(res => {
              if (res.code == 0) {
                  this.$message({
                  type: 'success',
                  message: '地址删除成功'
                })
                  this.getaddresslist()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
    },
    // 修改地址
    editAddress(item){
        console.log(item,'选择的每一项地址')
        this.areaName = item.areaName
        this.dialogVisible = true
        this.showEditButtom = true
        this.ruleForm = {
            muid:item.muid,
            said :item.said,
            recipient:item.recipient,
            phoneNumber:item.phoneNumber,
            areaid:item.areaid,
            address:item.address,
            postalCode:item.postalCode,
            defaultAddress:item.defaultAddress==1?true:false,
        }
    },
    // 地址查询
      getaddresslist() {
          this.loading = true
         addresslist({muid:this.userInfo.userId})
            .then(res => {
              if (res.code == 0) {
                  this.loading = false
                  if(res.rows.length>0){
                      this.addressLists = res.rows
                      if(this.addressLists.length>0){
                           this.addressLists.forEach((item,index)=>{
                            if(item.defaultAddress){
                                this.isSelectedAddress = index+1
                                this.addressitemObj = item
                                this.selected = true;
                                this.selectedAddressId = item.said
                                this.selectedAddress(this.isSelectedAddress,this.selectedAddressId,item)
                            }
                        })
                        let defaultAddressList =  this.addressLists.filter(item=>item.defaultAddress!=0)
                        if(defaultAddressList.length==0&&this.addressLists.length>0){
                            this.selected = true
                            this.isSelectedAddress = 1
                            this.selectedAddressId = this.addressLists[0].said
                            this.selectedAddress(1,this.selectedAddressId,this.addressLists[0])
                        }
                      }else{
                          this.selectedAddressId = ''
                      }
                  }else{
                      this.addressLists = []
                  }
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
    },

    openCommonProblem(){
        this.seeMoreCommonProblem = true
    },

    // 显示 去下单 的按钮说明没有选择地址id
    gotoAcount(){
        this.$message({
              type: 'info',
              message: '请选择地址'
            })
        return
    },

    // 查询我领过的相关商品的红包
    myReceivedPack(subtotal,mid){
        getMyred({
            muid:this.userInfo.userId,
            status:1,
            mid:mid, // 店铺id
            subtotal:subtotal,// 店铺里商品总价
        })
            .then(res => {
              if (res.code == 0) {
                  this.envelopeList = res.rows;
                  this.visible = true
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('查询收货失败，请稍后再试！')
            })
    },

     // 获取购物车
       getshoppingCartlist(){
           shoppingCartlist({uid:this.userInfo.userId||''})
               .then(res => {
                 this.$store.commit('getCartList',res)
            })
       },

    // 通过 立即购买 按钮跳转过来的 下单接口
    buyNowOrder(){
         if(this.selectedOrderList.length==0){
             this.$message({
                  type: 'info',
                  message: '暂无下单商品信息,请前去商场挑选商品'
                })
            return
        }

        let storePrice = []
        this.shopGoodsObj.forEach((item,index)=>{
            this.selectedOrderList.forEach(shop => {
              if (shop.bxmId == this.shopGoodsObj[index].bxmId){
                this.shopGoodsObj[index].onlineOrOffline = shop.onlineOrOffline
              }
            });
            this.shopGoodsObj[index].said = this.selectedAddressId
            this.shopGoodsObj[index].transpotfee = this.transportfeeNum(item.bxmId)
            this.shopGoodsObj[index].activitydiscountOffer = this.activityPriceReq
            this.shopGoodsObj[index].discountOffer = this.memberPriceReq
            this.selectedOrderList.forEach((shop)=>{ // 获取每个店铺的总金额
                storePrice.push(this.totalPrice(shop.goods,shop.redPackmoney,shop.bxmId))
            })
            this.shopGoodsObj[index].amount = storePrice[index] // 每个店铺下的总金额==每个订单的金额
        })
        const reqObj = this.shopGoodsObj[0];
        // 发票信息
         let bXyInvoice = {}
        if(this.invoiceType == 3){
            bXyInvoice={
                type:this.invoiceType,//是否是电子发票
                invoiceTitle:this.formLabelAlign.headerName,
                taxpayerNumber:this.formLabelAlign.taxNumber,
                address:this.formLabelAlign.registerAddress,
                tel:this.formLabelAlign.registerphone,
                bankAccount:this.formLabelAlign.bankNumber,
                bank:this.formLabelAlign.bank,
                invoiceName:this.formLabelAlign.invoiceName,
                invoiceTel:this.formLabelAlign.invoicePhone,
                invoiceAddress:`${this.formLabelAlign.invoiceAddress} ${this.formLabelAlign.invoiceAddressDetail}`,
            }
        }else{
             bXyInvoice={
                type:this.invoiceType,//是否是电子发票
                attribution:this.groupType, // 个人还是单位的
                invoiceTitle:this.formLabelAlign.headerName,
                taxpayerNumber:this.formLabelAlign.taxNumber,
            }
        }

        const req = {
                onlineOrOffline:reqObj.onlineOrOffline,
                bxmId:reqObj.bxmId,  //店铺id
                muid:this.userInfo.userId,  //买家ID
                redPay:reqObj.redPay,  //红包金额
                rid:reqObj.rid,	//红包id
                title:reqObj.title,	//标题
                amount:reqObj.amount,	//实付金额
                said:reqObj.said, //收货地址id
                id:reqObj.goodsList[0].id,	//商品id
                number:reqObj.goodsList[0].number,	//购买数量
                bxysid:reqObj.goodsList[0].bxysid||0,	//属性id
                pointfee: this.activityType==4?this.selectedOrderList[0].goods[0].needPoints :reqObj.goodsList[0].bXyFeeDetail.pointfee||0,	//使用积分数
                transpotfee:reqObj.transpotfee,	//运费
                goodsfee:reqObj.goodsList[0].realprice,	//商品费用
                manageId:'',
                type:this.selectedOrderList[0].goods[0].type,
                bXyInvoice:bXyInvoice,
                commodityType:this.selectedOrderList[0].goods[0].specificationlist?this.selectedOrderList[0].goods[0].specificationlist[0].activityTypeId:'',
            }
            if(this.activityType==1||this.activityType==3||this.activityType==5){ // 直接购买不需要参见满减、满送、加加购
                req.commodityType = ''
            }
        if(this.openradio == 2){
            // // 填写发票
            this.$refs.formLabelAlign.validate((valid) => {
                if (valid) {
                    this.isDisabled = true
                      if (this.$store.state.isThirdLogin) { // 三方登录
                        req.orderFrom = 2
                      }
                     immediatePlaceOrder(req)
                        .then(res => {
                        if (res.data.code == 0) {
                            sessionStorage.removeItem("selectList")
                            sessionStorage.setItem("orderGoodsInfo", JSON.stringify(res.data.data));
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                                });
                            if (req.onlineOrOffline == 2){
                              setTimeout(()=>{
                                this.$router.push('/myOrderRight');
                              },1000)
                            }else {
                              this.$router.push('/orderNow');
                            }
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.data.msg
                            })
                            this.isDisabled = false
                        }
                        })
                        .catch(err => {
                        this.$message.error('下单失败，请稍后再试！')
                        })
                }else{
                     this.$message({
                        type: 'info',
                        message: '请输入发票相关信息'
                     })
                }
            });
        }else{
            // 不需要发票
            this.isDisabled = true
            req.bXyInvoice={
                type:'',//是否是电子发票
                attribution:'', // 个人还是单位的
                invoiceTitle:'',
                taxpayerNumber:'',
            }
            if (this.$store.state.isThirdLogin) { // 三方登录
              req.orderFrom = 2
            }
             immediatePlaceOrder(req)
            .then(res => {
				console.log(res)
              if (res.data.code == 0) {
                  sessionStorage.removeItem("selectList")
                  sessionStorage.setItem("orderGoodsInfo", JSON.stringify(res.data.data));
                   this.$message({
                    type: 'success',
                    message: res.data.msg
                    });
                if (req.onlineOrOffline == 2){
                  setTimeout(()=>{
                    this.$router.push('/myOrderRight');
                  },1000)
                }else {
                  this.$router.push('/orderNow');
                }
              } else {
                this.$message({
                  type: 'info',
                  message: res.data.msg
                })
                this.isDisabled = false
              }
            })
            .catch(err => {
              this.$message.error('下单失败，请稍后再试！')
            })
        }

    },

    // 通过 购物车 跳转过来的 下单接口
    orderNow(){
        this.isDisabled = true
        if(this.selectedOrderList.length==0){
             this.$message({
                  type: 'info',
                  message: '暂无下单商品信息,请前去商场挑选商品'
                })
            return
        }
        let storePrice = []
        this.shopGoodsObj.forEach((item,index)=>{
            this.selectedOrderList.forEach(shop => {
              if (shop.bxmId == this.shopGoodsObj[index].bxmId){
                this.shopGoodsObj[index].onlineOrOffline = shop.onlineOrOffline
              }
            });
            this.shopGoodsObj[index].said = this.selectedAddressId
            this.shopGoodsObj[index].transpotfee = this.transportfeeNum(item.bxmId)
            this.shopGoodsObj[index].activitydiscountOffer = this.activityPriceReq
            this.shopGoodsObj[index].discountOffer = this.memberPriceReq
            this.selectedOrderList.forEach((shop)=>{ // 获取每个店铺的总金额
                storePrice.push(this.totalPrice(shop.goods,shop.redPackmoney,shop.bxmId))
            })
            this.shopGoodsObj[index].amount = storePrice[index] // 每个店铺下的总金额==每个订单的金额
        })

        // 发票信息
        let bXyInvoice={}
        if(this.invoiceType == 3){
            bXyInvoice={
                type:this.invoiceType,//是否是电子发票
                invoiceTitle:this.formLabelAlign.headerName,
                taxpayerNumber:this.formLabelAlign.taxNumber,
                address:this.formLabelAlign.registerAddress,
                tel:this.formLabelAlign.registerphone,
                bankAccount:this.formLabelAlign.bankNumber,
                bank:this.formLabelAlign.bank,
                invoiceName:this.formLabelAlign.invoiceName,
                invoiceTel:this.formLabelAlign.invoicePhone,
                invoiceAddress:`${this.formLabelAlign.invoiceAddress} ${this.formLabelAlign.invoiceAddressDetail}`,
            }
        }else{
             bXyInvoice={
                type:this.invoiceType,//是否是电子发票
                attribution:this.groupType, // 个人还是单位的
                invoiceTitle:this.formLabelAlign.headerName,
                taxpayerNumber:this.formLabelAlign.taxNumber,
            }
        }
        const req ={
            muid:this.userInfo.userId, //买家ID
            shopInfo:this.shopGoodsObj,//店铺ID及其商品集合
            scid:this.scidArr.toString(),
            bXyInvoice: bXyInvoice,
        }
        if(this.openradio == 2){
            // // 填写发票
            this.$refs.formLabelAlign.validate((valid) => {
                if (valid) {
                    if (this.$store.state.isThirdLogin) { // 三方登录
                      req.orderFrom = 2
                    }
                     addOrder(req)
                        .then(res => {
                        if (res.data.code == 0) {
                            this.getshoppingCartlist()
                            sessionStorage.removeItem("selectList")
                            // sessionStorage.setItem("account", JSON.stringify(this.payMoney()));  // 金额后期删除此处
                          let temp = []
                          res.data.data.forEach(item => {
                            if (item.onlineOrOffline != 2){
                              temp.push(item)
                            }else {
                              this.offlinePayMoney += item.amount
                            }
                          });
                          sessionStorage.setItem("orderGoodsInfo", JSON.stringify(temp));
                          sessionStorage.setItem("mergeFlag", JSON.stringify("false"));
                          sessionStorage.setItem("account", JSON.stringify(res.data.data[0].amount));
                          this.totalOrderNos=[];
                          this.totalOrderNos.push(res.data.data[0].totalOrderNo);
                          sessionStorage.setItem("totalOrderNos", JSON.stringify(this.totalOrderNos));
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                                })
                          // 如果全部店铺都是线下付款，则不需要付钱
                          let offlineNum = 0
                          this.shopGoodsObj.forEach((type)=>{ // 获取每个店铺的支付方式
                            if (type.onlineOrOffline == 2){
                              offlineNum += 1
                            }
                          });
                          if (offlineNum == this.shopGoodsObj.length){
                            setTimeout(()=>{
                              this.$router.push('/myOrderRight');
                            },1000)
                            return
                          }else {
                            this.$router.push('/orderNow?amount='+this.offlinePayMoney);
                          }
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.data.msg
                            })
                            this.isDisabled = false
                        }
                        })
                        .catch(err => {
                        this.$message.error('下单失败，请稍后再试！')
                        })
                }
            });
        }else{
            // 不需要发票
             req.bXyInvoice={
                type:'',//是否是电子发票
                attribution:'', // 个人还是单位的
                invoiceTitle:'',
                taxpayerNumber:'',
            };
              if (this.$store.state.isThirdLogin) { // 三方登录
                req.orderFrom = 2
              }
             addOrder(req)
            .then(res => {
              if (res.data.code == 0) {
                   this.getshoppingCartlist()
                  sessionStorage.removeItem("selectList")
                //   sessionStorage.setItem("account", JSON.stringify(this.payMoney()));  // 金额后期删除此处
                let temp = []
                res.data.data.forEach(item => {
                  if (item.onlineOrOffline != 2){
                    temp.push(item)
                  }else {
                    this.offlinePayMoney += item.amount
                  }
                });
                  sessionStorage.setItem("orderGoodsInfo", JSON.stringify(temp));
                  sessionStorage.setItem("mergeFlag", JSON.stringify("false"));
                  sessionStorage.setItem("account", JSON.stringify(res.data.data[0].amount));
                  this.totalOrderNos=[];
                  this.totalOrderNos.push(res.data.data[0].totalOrderNo);
                  sessionStorage.setItem("totalOrderNos", JSON.stringify(this.totalOrderNos));
                   this.$message({
                    type: 'success',
                    message: res.data.msg
                    });
                // 如果全部店铺都是线下付款，则不需要付钱
                let offlineNum = 0;
                this.shopGoodsObj.forEach((type)=>{ // 获取每个店铺的支付方式
                  if (type.onlineOrOffline == 2){
                    offlineNum += 1
                  }
                });
                if (offlineNum == this.shopGoodsObj.length){
                  setTimeout(()=>{
                    this.$router.push('/myOrderRight');
                  },1000);
                  return
                }else {
                  this.$router.push('/orderNow?amount='+this.offlinePayMoney);
                }
              } else {
                this.$message({
                  type: 'info',
                  message: res.data.msg
                })
                this.isDisabled = false
              }
            })
            .catch(err => {
              this.$message.error('下单失败，请稍后再试！')
            })
        }
    },
    //调用覆盖接口
    getCoverPrice(){
        coveragePrice({id:this.$route.query.scId,userId:this.userInfo.userId}).then(res => {
            this.selectedOrderList[0].goods[0].bxyFeeDetail.memberdiscount = res.data.memberdiscount;
             this.selectedOrderList[0].goods[0].realprice = res.data.price;
             this.selectedOrderList[0].goods[0].goodsfee = res.data.price;
        })
    }
  },
};
</script>

<style scoped lang="less">
.wholeBox{
    padding:30px;
    background: white;
    .isActive{
        border: 1px solid #78b942 !important;
        background: #f1f6fd;
    }
    .infoBox{
        .textRedColor{
            color:#78b942;
        }
    }
    .getaddressList{
        margin: 20px 0;
        display: flex;
        justify-content: flex-start;
        .addHover{
            padding: 63px 30px !important;
        }
        .addHover:hover{
            cursor: pointer;
            color:#78b942;
        }
        .defaultAddressColor{
            color: #78b942;
            position: absolute;
        }
        .getaddressItem{
            border: 1px solid #ccc;
            display: inline-block;
            padding: 30px;
            box-sizing: border-box;
            margin-right: 20px;
            width: 240px;
            cursor: pointer;
            margin-bottom: 10px;
            min-height: 208px;
            .addIcon{
                font-size: 30px;
                text-align: center;
                display: block;
                margin-bottom: 10px;
                margin-top: 15px;
            }
            p{
                line-height: 25px;
            }
            .addressColor{
                text-align: right;
                position: relative;
                bottom: -20px;
                color: #78b942;
                cursor: pointer;
                font-size: 14px;
                span{
                    display: inline-block;
                    margin-left: 15px;
                }
                .delete{
                    /deep/button.el-button.el-button--default.el-popover__reference {
                        border: 0px;
                        color: #78b942;
                        padding: 0;
                    }
                    /deep/.el-button:focus, .el-button:hover{
                        background: transparent;
                    }

                }
            }
        }
    }

}

.wholeRedBox {
  display: flex;
  justify-content: flex-start;
  width: 190px;
  height: 100px;
  border: 1px solid #eaeaea;
  margin-bottom: 10px;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  .img-responsive {
    width: 60px;
    height: 60px;
    text-align: center;
    top: 10%;
    position: relative;
    }
.text_right{
    margin-left: 10px;
}
button.el-button.buttonBgd.el-button--primary {
    color: #fff;
    background-color: #78b942;
    border-color: #e65d00;
    width: 180px;
    margin-left: 12px;
    margin-top: 5px;
    font-size: 14px;
}
.getNow {
  margin-top: 1px;
  background-color: #d93600;
  padding: 7px 15px;
  font-size: 15px;
  color: white;
}
//   .el-button--text.is-disabled {
//       color: #e4e7ed;
//       background-color: #999;
//   }
}
.payMethodsNew{
  /deep/.el-radio-button__orig-radio+.el-radio-button__inner {
    background: transparent;
    line-height: 0;
  }
  /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
    border-color: #78b942;
    color: #78b942;
    background: transparent;
    line-height: 0;
  }
}
.orderBox{
    padding: 0 27px;
    background: white;
    .payMethods{
        padding: 30px !important;
        background: white !important;
        border-bottom: 1px solid #ccc !important;
        /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
            border-color: #78b942;
            color: #78b942;
            background: transparent;
            line-height: 0px;
        }
        .invoiceBox{
            margin: 10px;
            .el-radio-group{
                display: block;
                margin: 25px 0;
                /deep/.el-radio-button__inner{
                    width: 160px;
                    line-height: 0px;
                }
            }
            .more{
                font-size: 14px;
                .active{
                    color: #78b942;
                    a{
                       color: #78b942 !important;
                    }
                }
            }
        }

    }
/deep/.el-row.payMethods {
            // line-height: 40px;
            font-size: 18px;
        }
    .orderDetailText {
        display: flex;
        justify-content: space-between;
        padding: 40px 0px 5px 27px;
        background: white;
        font-size: 18px;
        a{
            color: #b0b0b0;
        }
    }
    .order_Info{
        font-size: 14px;
        .el-image{
            height: 30px;
            width: 30px;
        }
        .order_Info_item{
            line-height: 30px;
        }
        span.addIcon {
            background: #78b942;
            color: white;
            font-size: 12px;
            margin-left: 10px;
            padding: 2px 5px;
            box-sizing: border-box;
            border-radius: 4px;
        }
    }
    .order_detailInfo{
        padding: 10px 27px;
        // border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        font-size: 14px;
        background: white;
        .nodate {
            text-align: center;
            margin: 70px;
            font-size: 16px;
        }
        .order_detailInfo_price{
            padding: 0 60px;
            color: #78b942;
            span.addIcon {
                background: #78b942;
                color: white;
                font-size: 12px;
                margin-left: 10px;
                padding: 2px 8px;
                box-sizing: border-box;
                border-radius: 4px;
            }
        }
    }
    .Fee_Dtails{
        font-size: 14px;
        padding: 27px 0 27px 27px;
        background: white;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        .Fee_Dtails_add{
            i.el-icon-circle-plus {
                color: #ff9a00;
                font-size: 30px;
                vertical-align: middle;
                cursor: pointer;
            }
            .use_red{
               text-align: center;
               p{
                   font-size: 18px;
                   color: #757575;
                   text-align: left;
                   padding: 0 20px;
                   box-sizing: border-box;
               }

               div {
                //    height: 180px;
                //    line-height: 180px;
               }
            }
            .envelopeListBox{
                /deep/.el-popover{
                    width: 800px;
                }
            }

        }
        .order_Info_item{
            line-height: 30px;
            color: #757575;
        }
        .Fee_Dtails_money{
            text-align: right;
            .order_Info_item{
                color: #78b942 !important;
            }
        }
        .Fee_Dtails_info{
            display: flex;
            .Fee_Dtails_item.el-row {
                text-align: right;
            }
        }

    }
    .order_detailInfo .Fee_Dtails:last-child{
        border-bottom: 0px;
    }
    .total_price{
        font-size: 25px;
        text-align: right;
        margin: 20px 0 20px 0;
        // border-bottom: 1px solid #ccc;
        background: white;
        .total_price_color{
            color: #78b942;
            font-weight: bold;
        }
    }

}
 button.el-button.buttonBgd.el-button--primary {
        background-color: #78b942;
        border-color: #78b942;
        font-size: 14px;
        margin-bottom: 20px;
    }
.cascaderArea.el-cascader {
    width: 100%;
    /deep/input[disabled], /deep/input[disabled="disabled"], /deep/input[readonly], /deep/input[readonly="readonly"] {
    background-color: white;
}
}
.seeMoreCommonProblemBox{

    /deep/.el-dialog__body{
        text-align: center !important;
        .modalContent{
            text-align: left;
            padding-bottom: 20px;
        }
    }
}
.addressCss{
    display: flex;
    justify-content: space-between;
    .editCss{
        color: #78b942;
        cursor: pointer;
    }
}

</style>







// WEBPACK FOOTER //
// src/views/shoppingcart/orderDetail.vue